<button
  appearance="outline"
  class="shrink-0 rounded-full!"
  data-testid="previous-button"
  iconStart="@tui.chevron-left"
  size="s"
  tuiIconButton
  type="button"
  [disabled]="(canGoToPrevious$ | async) === false"
  (click)="examinationNavigationService.goToPrevious()"></button>

<div class="flex min-w-0 flex-1 flex-col items-center">
  <ng-content />
  <tui-pager [count]="(length$ | async) || 0" [index]="(index$ | async) || 0" [max]="maxDots" />
</div>

<button
  appearance="outline"
  class="shrink-0 rounded-full!"
  data-testid="next-button"
  iconStart="@tui.chevron-right"
  size="s"
  tuiIconButton
  type="button"
  [disabled]="(canGoToNext$ | async) === false"
  (click)="examinationNavigationService.goToNext()"></button>
